<script>
/**
 * 検索パターン登録モーダル
 */
import { mapActions } from "vuex";

export default {
  name: "RegisterConditionPatternModal",
  components: {},
  mixins: [],
  props: {
    enable: {
      type: Boolean,
      default: false,
    },
    /**
     * 機能種別
     */
    classification: {
      type: String,
      default: null,
    },
    conditions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: null,
        classification: null,
        conditions: {},
      },
    };
  },
  watch: {
    enable(value) {
      this.$nextTick(() => this.$refs.observer.reset());
      Object.assign(this.form, this.$options.data().form);
      if (value) {
        this.form.classification = this.classification;
        this.form.conditions = this.conditions;
      }
    },
  },
  created: {},
  methods: {
    ...mapActions("DriverMasterConditionPattern", {
      createConditionPattern: "create",
    }),
    closeButtonClickEvent() {
      this.$emit("close");
    },
    registerButtonClickEvent() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.register();
        }
      });
    },
    register() {
      this.createConditionPattern({ params: this.form }).then((content) => {
        this.$emit("register", content);
      });
    },
  },
};
</script>
<template>
  <div>
    <v-dialog
      :value="enable"
      width="600"
      @click:outside="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <validation-observer ref="observer">
        <v-card flat>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>検索パターン登録</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="closeButtonClickEvent"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text class="pt-2">
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="パターン名"
                  rules="required|max:25"
                >
                  <v-text-field
                    v-model="form.name"
                    :error-messages="errors"
                    outlined
                    dense
                    hide-details="auto"
                    persistent-hint
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>パターン名</span>
                      <span class="ml-1">
                        ({{ form.name?.length || 0 }} / 25)
                      </span>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">キャンセル</v-btn>
            <v-btn class="primary" @click="registerButtonClickEvent"
              >登録</v-btn
            >
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>
